import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px;
`;

const StyledTitle = styled(Text)`
	font-weight: 500;
	font-size: 18px;
	text-align: center;
	color: #ffffff;
`;

const StyledGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 5px;
	grid-row: 80px;
	height: 420px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledPhotoItemWrapper = styled.div`
	cursor: pointer;
	opacity: 0.5;
	transition: opacity 0.3s ease;

	&:hover {
		opacity: 1;
	}
`;

const StyledPhotoItem = styled.img`
	width: 100%;
	height: 80px;
	object-fit: cover;
	border-radius: 10px;
	user-select: none;
	pointer-events: none;
`;

export {
	StyledContainer,
	StyledGrid,
	StyledPhotoItem,
	StyledPhotoItemWrapper,
	StyledTitle,
};
